import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 62F96579-80AE-4827-9C18-1C1FD239DE49
 * name facebook-gaming
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/facebook-gaming.svg
 * tags
 * - Brand / Logo 
 */
export const FacebookGamingIcon = createSvgIcon(<><path d="M9.5 14.5V9.5H21V21H15.5V14.5H9.5M3 3H21L21 8.5H8.5V15.5H14.5V21H3V3Z" /></>, 'FacebookGamingIcon');
export default FacebookGamingIcon